module.exports = __webpack_public_path__ + "img/monitoring-tow-red.281a3849.svg";